<script lang="ts" setup>
useScript({
  src: 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.2.0/model-viewer.min.js',
  type: 'module',
})

const { width = 900, height = 1600 } = defineProps<{
  height?: number
  width?: number
}>()

const modelViewer = useTemplateRef('model-viewer')

defineExpose({
  modelViewer,
})
</script>

<template>
  <model-viewer
    ref="model-viewer"
    :style="`--aspect-ratio: ${width} / ${height};`"
  >
    <slot />
  </model-viewer>
</template>

<style>
model-viewer {
  aspect-ratio: var(--aspect-ratio);
  display: block;
  height: auto;
  width: 100%;
}
</style>
